import Joi from 'joi'
import errorsResolver from '../../../../validation/schemeUtils'

const warningCheckingForInvalidCharacters = `Поле ввода содержит некорректные символы`;
const additionalInfoLength = 300

export const addPuritySchemaFunc = (configure) => {
    const NAME_FIELD_LENGTH = configure ? 20 : 60
    const COMMENT_FIELD_LENGTH = configure ? 14 : 90
    const ADD_INFO_FIELD_LENGTH = configure ? 20 : 90
    const IS_PART_NAME_LENGTH = configure ? 21 : 60;

    const puritySchema = Joi.object({
        isPart: Joi.bool(),
        jewel: Joi.when('isPart', {
            is: true,
            then: Joi.object({
                value: Joi.alternatives().try(Joi.number(), Joi.string()),
                label: Joi.string()
                    .max(IS_PART_NAME_LENGTH)
                    .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.\\-,+!{}#( )$%^&*~_:?"/\\\\]*$'))
                    .error(
                        errorsResolver({
                            pattern: `Название содержит некорректные символы`,
                            max: `Название должно быть до ${IS_PART_NAME_LENGTH} символов`,
                        })
                    ),
                part: Joi.any()
            }),
            otherwise: Joi.object({
                value: Joi.alternatives().try(Joi.number(), Joi.string()),
                label: Joi.string()
                    .max(NAME_FIELD_LENGTH)
                    .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.\\-,+!{}#( )$%^&*~_:?"/\\\\]*$'))
                    .error(
                        errorsResolver({
                            pattern: `Название содержит некорректные символы`,
                            max: `Название должно быть до ${NAME_FIELD_LENGTH} символов`,
                        })
                    ),
                part: Joi.any()
            })
                .invalid(null)
                .required()
                .error(errorsResolver({
                    invalid: `Название обязательное поле`,
                    required: `Название обязательное поле`,
                })),
        }),
        purity: Joi.object({value: Joi.number(), label: Joi.any()})
            .required()
            .error(errorsResolver({
                numberBase: 'Проба обязательное поле'
            })),
        quantity: Joi.number()
            .required()
            .min(1)
            .empty('')
            .error(errorsResolver({
                required: 'Количество обязательное поле',
                numberBase: 'Количество должно быть числом',
                numberMin: 'Количество должно быть больше 0',
                numberUnsafe: 'Некорректное число'
            })),
        grossWeight: Joi.number()
            .required()
            .not(0)
            .invalid('-', '0', '0.', '0.0', '0.00', '000', '00.0', '-0', '-0.', '-0.0', '-0.00', '-000', '-00.0')
            .error(errorsResolver({
                required: 'Общий вес обязательное поле',
                invalid: 'Общий вес обязательное поле',
                number: 'Общий вес обязательное поле или должен быть числом',
            })),
        pureWeight: Joi.number()
            .not(0)
            .required()
            .error(errorsResolver({
                required: 'Лигатурный вес обязательное поле',
                invalid: 'Лигатурный вес обязательное поле или должен быть числом',
                number: 'Лигатурный вес обязательное поле или должен быть числом',
                numberUnsafe: 'Лигатурный вес обязательное поле или должен быть числом',
            })),
        puritiesComment: Joi.string()
            .allow('')
            .max(COMMENT_FIELD_LENGTH)
            .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.+\\-,!( )_:?";]*$'))
            .error(errorsResolver({
                max: `Вставка должна быть меньше или равна ${COMMENT_FIELD_LENGTH} символам`,
                pattern: warningCheckingForInvalidCharacters
            })),
        showComment: Joi.bool(),
        additionalInfo: Joi.string()
            .allow('')
            .max(ADD_INFO_FIELD_LENGTH)
            .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.+-,-!()_/,№:?”;" ]*$'))
            .error(errorsResolver({
                max: `Длина доп. описания должна быть меньше или равна ${ADD_INFO_FIELD_LENGTH} символам`,
                pattern: warningCheckingForInvalidCharacters
            })),
    })

    return Joi.object({
        purities: Joi.array().items(puritySchema),
        additionalInformation: Joi.string()
            .allow('')
            .max(additionalInfoLength)
            .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.\\-,/+!{}#()$%^&*~_№:?"\\\\ \\n]*$'))
            .error(errorsResolver({
                max: `Длина комментария должна быть меньше или равна ${additionalInfoLength} символам`,
                pattern: warningCheckingForInvalidCharacters,
            })),
    })
}



